// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1zLnE","inner":"Footer_inner__1QPNy"};